import React from 'react'
import classNames from 'classnames'
import { useField } from 'formik'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { getCurrencyMaskOption } from '../../utils/maskOptionHelper'

const CurrencyInput = ({ onBlur, experienceStyle = false, ...rest }) => {
  const [field, meta] = useField({ name: rest.name, type: rest.type })

  const handleBlur = (e) => {
    field.onBlur(e)
    if (typeof onBlur === 'function') {
      onBlur(e)
    }
  }

  const useExperienceChrome =
    experienceStyle ||
    (rest.inputClasses &&
      String(rest.inputClasses).includes('experience-f-control'))

  return (
    <MaskedInput
      {...field}
      mask={createNumberMask(getCurrencyMaskOption())}
      maskOptions={getCurrencyMaskOption()}
      type='text'
      className={classNames(
        'form-control',
        {
          'is-valid': !useExperienceChrome && meta.touched && !meta.error,
          'is-invalid': meta.touched && meta.error,
        },
        rest.inputClasses,
      )}
      {...rest}
      onBlur={handleBlur}
    />
  )
}

export default CurrencyInput
